module.exports = __webpack_public_path__ + "img/public_office_analysis.354972c3.png";